import RepurchaseDefinition from '../../shared/partials/repurchase-definition.en.mdx';

export const title = 'Orders composition';

Break down of orders made by the app. Here you can see:
- How many orders are from new customers;
- How many are from customers who previously bought on your website and made their first purchase via the app; and
- How many are from customers who previously bought via the app and purchased again via the app.

The higher the share of repurchases in the app, the better. This means that your app is working and functioning as a tool for customer loyalty and repeat purchases!

